import { render } from "./Books.vue?vue&type=template&id=d56eabaa&scoped=true&ts=true"
import script from "./Books.vue?vue&type=script&lang=ts"
export * from "./Books.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56eabaa"]])

export default __exports__